import { fetchPOST } from "../Tools";

export default class CKEditor {
    static firstInit = true;

    constructor(container: HTMLElement = document.body) {
        const _this = this;
        container.querySelectorAll('.ckedit.editmode').forEach((el: HTMLElement) => {
            if (!el.textContent.trim().length) {
                el.classList.add('placeholder');
            }
            el.addEventListener('input', () => {
                _this.toggleClass(el);
            });
            el.addEventListener('change', () => {
                _this.toggleClass(el);
            });
            el.addEventListener('focus', () => {
                _this.toggleClass(el);
            });
            el.addEventListener('blur', () => {
                _this.toggleClass(el);
            });
        });
        if (CKEditor.firstInit) {
            CKEditor.firstInit = false;
            window.addEventListener('ckedit-drop', (ev: CustomEvent) => {
                if (ev.detail.editor) {
                    Array.from(ev.detail.editor).forEach( (element: HTMLElement) => {
                        new CKEditor(element.parentElement);
                    });
                }
            });
        }
        // WWS-20 textbausteine
        (<NodeListOf<HTMLSelectElement>>document.querySelectorAll('select.js-select-textbaustein')).forEach( select => {
            const editor = document.getElementById(select.dataset.connectId);
            $(select).selectmenu({
                change: async function (event, ui) {
                    if ((<any>ui.item).value === '') {
                        editor.innerHTML = '';
                        editor.classList.add('placeholder');
                        return;
                    }
                    let blockData = {
                        data: {
                            type: 'get',
                            id: <number>(<any>ui.item).value,
                        }
                    };
                    const result = await fetchPOST('/Handler/HvD/Textblock', blockData.data, false);
                    editor.innerHTML = result;
                    editor.classList.remove('placeholder');
                }
            });
            const selectorWidget = $(select).selectmenu('widget');
            selectorWidget[0].classList.add('max-width');
        });
    }

    private toggleClass(el: HTMLElement) {
        if (!el.textContent.trim().length) {
            el.classList.add('placeholder');
        } else {
            el.classList.remove('placeholder');
        }
    }
}
